// DEV-ONLY: the real Feed with made-up people, and buttons to fire what really happens to it.
// Open http://localhost:3000/?feedPreview  (never active in a production build)
import React, { useRef, useState } from 'react';
import Feed from '../components/Feed';

const ago = (mins) => new Date(Date.now() - mins * 60000).toISOString();
const team = (abbrev, name) => ({ abbrev, name, logo: `https://assets.nhle.com/logos/nhl/svg/${abbrev}_light.svg` });
const GAMES = {
  'Calgary vs Seattle': { home: team('CGY', 'Calgary'), away: team('SEA', 'Seattle') },
  'Florida vs Winnipeg': { home: team('FLA', 'Florida'), away: team('WPG', 'Winnipeg') },
  'Vegas vs New Jersey': { home: team('VGK', 'Vegas'), away: team('NJD', 'New Jersey') },
  'Montréal vs Boston': { home: team('MTL', 'Montréal'), away: team('BOS', 'Boston') },
  'Toronto vs Ottawa': { home: team('TOR', 'Toronto'), away: team('OTT', 'Ottawa') },
};
const NAMES = Object.keys(GAMES);
const PEOPLE = [{ id: 'a', username: 'CL34RY' }, { id: 'b', username: 'DI4N3' }, { id: 'c', username: 'Marc88' }, { id: 'd', username: 'Chungussifu' }];
const PICKS = ['Seattle +1.5', 'Calgary -1.5', 'Winnipeg +1.5', 'Florida to win', 'Vegas -1.5', 'New Jersey +1.5', 'Montréal to win', 'Boston +1.5', 'Toronto to win', 'Ottawa +1.5'];
const GAME_OF = [0, 0, 1, 1, 2, 2, 3, 3, 4, 4];

let nextId = 100;
const bet = (user_id, i, stake, odds, extra = {}) => ({ id: nextId++, user_id, game_id: NAMES[GAME_OF[i % 10]], game_description: NAMES[GAME_OF[i % 10]], pick: PICKS[i % 10], stake, odds, bet_type: 'spread', status: 'pending', ...extra });
const placed = (b, mins) => ({ kind: 'placed', likeKey: `bet:${b.id}`, user_id: b.user_id, bet: b, legs: b.legs || 0, at: ago(mins) });
const settled = (b, result, mins) => ({ ...b, status: 'settled', result, payout: result === 'won' ? b.stake * b.odds : 0, settled_at: ago(mins) });

const startItems = () => [
  { kind: 'boost', likeKey: 'event:boost', at: ago(2) },
  placed(bet('b', 0, 40, 2.6), 4),
  ...Array.from({ length: 8 }, (_, i) => placed(bet('a', i, 1000 - i * 80, 1.8 + i * 0.2), 20 + i * 0.2)),
  placed(settled(bet('d', 6, 1500, 3), 'won', 33), 200),
  placed(settled(bet('c', 8, 80, 2.5), 'won', 41), 210),
  placed(settled(bet('d', 7, 500, 1.9), 'lost', 48), 220),
  ...[0, 1, 2, 3].map((i) => placed(bet('c', i + 2, 60 + i * 30, 2.2), 62 + i)),
  { kind: 'predict', likeKey: 'predict:1', user_id: 'c', amount: 125, at: ago(70) },
  placed(bet('d', 0, 500, 7.04, { bet_type: 'parlay', legs: 4 }), 88),
  ...[0, 1, 2, 3, 4, 5, 6].map((i) => placed(settled(bet('b', i, 100 + i * 50, 2.1), i % 3 === 2 ? 'lost' : 'won', 25), 180 + i)),
  { kind: 'spin', likeKey: 'spin:1', user_id: 'b', amount: 300, at: ago(190) },
  ...[0, 1, 2].map((i) => placed(settled(bet('a', i + 4, 200, 2), i === 1 ? 'lost' : 'won', 220), 230 + i)),
  { kind: 'won', likeKey: 'bet:parlaywin', user_id: 'd', legs: 3, bet: { id: 'parlaywin', user_id: 'd', stake: 100, odds: 9.8, payout: 980, bet_type: 'parlay', status: 'settled', result: 'won' }, at: ago(260) },
  placed(bet('c', 9, 75, 1.9, { game_id: 'none', game_description: 'F1 · Mexico City Grand Prix', pick: 'Verstappen to win' }), 300),
  ...[['a', 2500], ['c', 1200], ['b', 600]].map(([user_id, amount], i) => ({ kind: 'jackpot', likeKey: `jackpot:2026-09:${user_id}`, user_id, amount, place: i + 1, month: '2026-09', at: ago(400) })),
].sort((a, b) => new Date(b.at) - new Date(a.at));

const money = (n) => `$${(+n).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function FeedPreview() {
  const [items, setItems] = useState(startItems);
  const [likes, setLikes] = useState({ 'bet:101': [{ id: 1, user_id: 'b' }, { id: 2, user_id: 'c' }, { id: 3, user_id: 'd' }] });
  const [scores, setScores] = useState({ 'Calgary vs Seattle': { as: 1, hs: 2 } });
  const [lang, setLang] = useState('en');
  const flameAt = useRef(0);

  const onLike = (key) => setLikes((prev) => {
    const list = prev[key] || [];
    return { ...prev, [key]: list.some((l) => l.user_id === 'a') ? list.filter((l) => l.user_id !== 'a') : [...list, { id: nextId++, user_id: 'a' }] };
  });
  const flame = () => {
    const keys = [...document.querySelectorAll('[data-like]')].filter((el) => { const r = el.getBoundingClientRect(); return r.top > 40 && r.bottom < window.innerHeight - 40; }).map((el) => el.dataset.like);
    const key = keys[flameAt.current++ % keys.length];
    if (!key) return;
    setLikes((prev) => {
      const list = prev[key] || [];
      const who = ['b', 'c', 'd'].find((id) => !list.some((l) => l.user_id === id));
      return who ? { ...prev, [key]: [...list, { id: nextId++, user_id: who, created_at: new Date().toISOString() }] } : prev;
    });
  };
  // settles the open bets of the first post that has any
  const settleRows = (count, result) => setItems((list) => {
    const open = list.filter((i) => i.kind === 'placed' && i.bet.status === 'pending' && i.bet.user_id === 'a');
    const pool = open.length ? open : list.filter((i) => i.kind === 'placed' && i.bet.status === 'pending');
    const pick = new Set(pool.slice(0, count).map((i) => i.likeKey));
    return list.map((i) => (pick.has(i.likeKey) ? { ...i, bet: settled(i.bet, result(i), 0) } : i));
  });
  const addPost = (n, user_id) => setItems((list) => [...Array.from({ length: n }, (_, i) => placed(bet(user_id, i + nextId, 60 + i * 40, 2.3), 0)), ...list]);
  const add = (item) => setItems((list) => [{ ...item, at: ago(0) }, ...list]);
  const settleSolo = (result, stake, odds) => {
    const b = bet('d', nextId, stake, odds);
    setItems((list) => [placed(b, 16), ...list]);
    setTimeout(() => setItems((list) => list.map((i) => (i.likeKey === `bet:${b.id}` ? { ...i, bet: settled(b, result, 0) } : i))), 1200);
  };
  const ACTIONS = [
    ["Friend's flame", flame],
    ['Row wins', () => settleRows(1, () => 'won')],
    ['Row loses', () => settleRows(1, () => 'lost')],
    ['Close CL34RY', () => settleRows(99, (i) => (i.likeKey.length % 2 ? 'won' : 'lost'))],
    ['New post', () => addPost(1, 'c')],
    ['New 4 bets', () => addPost(4, 'b')],
    ['Bet joins', () => addPost(1, 'b')],
    ['Goal', () => setScores((s) => ({ ...s, 'Calgary vs Seattle': { ...s['Calgary vs Seattle'], hs: s['Calgary vs Seattle'].hs + 1 } }))],
    ['Small win', () => settleSolo('won', 50, 2)],
    ['Loss', () => settleSolo('lost', 300, 2)],
    ['Win', () => settleSolo('won', 300, 2.5)],
    ['Big win', () => settleSolo('won', 1500, 3)],
    ['Spin', () => add({ kind: 'spin', likeKey: `spin:${nextId++}`, user_id: 'c', amount: 640 })],
    ['Predict', () => add({ kind: 'predict', likeKey: `predict:${nextId++}`, user_id: 'b', amount: 210 })],
    ['Français', () => setLang((l) => (l === 'fr' ? 'en' : 'fr'))],
  ];
  const liveOf = (b) => {
    const s = scores[b.game_description];
    const g = GAMES[b.game_description];
    return s && g ? { period: '2nd', away: g.away.abbrev, home: g.home.abbrev, as: s.as, hs: s.hs } : null;
  };
  return (
    <div style={{ padding: 16, minHeight: '100vh', background: 'var(--fl-surface-2)', color: 'var(--text)' }}>
      <Feed
        items={items} loaded failed={false} likes={likes} onLike={onLike} profile={PEOPLE[0]} players={PEOPLE} liveOf={liveOf}
        avatarOf={() => null} gameInfo={(b) => GAMES[b.game_description] || null} lang={lang} money={money} betText={(b) => b.pick}
      />
      <div style={{ position: 'fixed', left: 8, bottom: 8, zIndex: 30, display: 'flex', flexWrap: 'wrap', gap: 4, maxWidth: 300, padding: 6, border: '1px dashed var(--text-muted)', borderRadius: 8, background: 'var(--fl-surface)' }}>
        {ACTIONS.map(([label, fn]) => <button type="button" key={label} data-sim={label} onClick={fn} style={{ padding: '3px 6px', fontSize: 11, cursor: 'pointer' }}>{label}</button>)}
      </div>
    </div>
  );
}
